export default [
    // items 商品
  {
    path: '/scenarios/items/:id',
    name: 'scenarios-items',
    component: () => import('@/views/Scenarios/index'),
    children: []
  }
]